var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.27309 8.55352V14.9802C6.27309 15.0735 6.34642 15.1468 6.43975 15.1468H8.82642C8.91975 15.1468 8.99309 15.0735 8.99309 14.9802V8.44685H10.7264C10.8131 8.44685 10.8864 8.38018 10.8931 8.29352L11.0598 6.32685C11.0664 6.22685 10.9931 6.14685 10.8931 6.14685H8.99309V4.74685C8.99309 4.42018 9.25975 4.15352 9.58642 4.15352H10.9198C11.0131 4.15352 11.0864 4.08018 11.0864 3.98685V2.02018C11.0864 1.92685 11.0131 1.85352 10.9198 1.85352H8.66642C7.34642 1.85352 6.27309 2.92685 6.27309 4.24685V6.14685H5.07975C4.98642 6.14685 4.91309 6.22018 4.91309 6.31352V8.28018C4.91309 8.37352 4.98642 8.44685 5.07975 8.44685H6.26642L6.27309 8.55352Z",
    fill: "#1778F2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.3f6d2c0b4f3ca5da906c3c85e496abbe.svg";
export { ForwardRef as ReactComponent };